import { useQuery } from '@tanstack/react-query';

import { fetchSessionStatus } from '../../fetch/fetchSessionStatus';

export default function useFetchSessionStatus(sessionId) {
  return useQuery({
    queryKey: ['xtramBotSessionStatus', sessionId],
    queryFn: () => fetchSessionStatus(sessionId),
    enabled: !!sessionId,
    retry: false,
  });
}

